var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPinkQuoteSmall = function SvgPinkQuoteSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.64 18.869c.001 1.126.388 2.218 1.097 3.093l6.235 7.694c.634.782 1.9.334 1.9-.673v-7.325c0-.59.478-1.069 1.069-1.069h7.83c.59 0 1.07-.479 1.07-1.069V1.069C42.84.479 42.36 0 41.77 0H26.207a2.565 2.565 0 00-2.566 2.566v16.303zM.91 18.869c0 1.126.387 2.218 1.096 3.093l6.235 7.694c.634.782 1.9.334 1.9-.673v-7.325c0-.59.478-1.069 1.069-1.069h7.83c.59 0 1.07-.479 1.07-1.069V1.069C20.11.479 19.63 0 19.04 0H3.476A2.566 2.566 0 00.909 2.566v16.303z",
    fill: "#F05"
  })));
};
export default SvgPinkQuoteSmall;